import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import AppointmentFaqContainer from '../../../../components/AppointmentFaq/AppointmentFaqContainer.js';
import AppointmentTypesContainer from '../../../../components/AppointmentTypes/AppointmentTypesContainer.js';
import { getBookAppointmentStore } from '../../data/book-appointment-store-by-id.js';
import { getBookAppointmentType } from '../../data/book-appointment-type.js';
import { MissingStoreIdError, AlternativeUrlStoreError, InvalidVirtualAppointmentError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError, AlternativeLinkedAppointmentTypeNotValidError } from '../../errors.js';
import { getFormattedParams, hasValidVirtualAppointmentParams, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from '../../utils.js';

const WhatRoot = ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(AppointmentTypesContainer, null), /*#__PURE__*/ React.createElement(AppointmentFaqContainer, null))
;
WhatRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        if (formattedParams.globalStoreId === undefined) {
            throw MissingStoreIdError();
        }
        if ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.globalStoreId)) {
            throw AlternativeUrlStoreError();
        }
        // This route should not be visited with any virtual appointment params, valid or invalid.
        if (hasValidVirtualAppointmentParams(formattedParams) || hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        }
        const [store, type] = yield Promise.all([
            getBookAppointmentStore(apolloClient, formattedParams.globalStoreId, locale, formattedParams.tryInStoreFlow),
            getBookAppointmentType(apolloClient, formattedParams.typeId, locale), 
        ]);
        if (!store) {
            throw StoreNotFoundError();
        } else if (formattedParams.typeId && !type) {
            throw TypeNotFoundError();
        } else if (type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !isAppointmentTypeValid({
            typeId: formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId,
            store
        })) {
            throw LinkedAppointmentTypeNotValidError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.alternativeLinkedAppointmentTypeId) && !isAppointmentTypeValid({
            typeId: formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.alternativeLinkedAppointmentTypeId,
            store
        })) {
            throw AlternativeLinkedAppointmentTypeNotValidError();
        }
        return Promise.resolve({
            store,
            type,
            timeSlot: null
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

export { WhatRoot as default };
//# sourceMappingURL=WhatRoot.js.map
